<template>
  <el-card class="box-card user-card">
    <div>
      <div>
        <img src="https://www.wch.cn/img/404.dc2d93d1.png" alt class="img_"/>
        <!-- <h1>404</h1>
        <p>哎呀！您查找的页面不存在。</p> -->
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      list: null,
      listLoading: true,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      console.info(this.$route.params);
    },
  },
};
</script>
<style lang="less">
.container404 {
  text-align: center;
  color: #333;

  h1 {
    font-size: 10rem;
    margin: 0;
    color: #e74c3c;
  }
  p {
    font-size: 1.2rem;
    margin-bottom: 2rem;
  }
  a {
    display: inline-block;
    padding: 10px 20px;
    font-size: 1rem;
    color: #fff;
    background-color: #3498db;
    text-decoration: none;
    border-radius: 5px;
    transition: background-color 0.3s ease;
  }
  a:hover {
    background-color: #2980b9;
  }
}
</style>
